export default __webpack_public_path__ + "static/media/Keywords.8f616449.jpeg";